/**
 * Logger mínimo para el frontend.
 *
 * - info/debug: solo en desarrollo (silenciados en producción).
 * - warn/error: siempre activos (útil para reporting a un endpoint o
 *   integración con Sentry en el futuro).
 *
 * Uso:
 *   import { log } from '@/utils/logger';
 *   log.info('Usuario cargado', user);
 *   log.error('Error al guardar', err);
 */
const isDev = process.env.NODE_ENV !== 'production';

/* eslint-disable no-console */
export const log = {
  info: (...args) => isDev && console.info('[INFO]', ...args),
  debug: (...args) => isDev && console.debug('[DEBUG]', ...args),
  warn: (...args) => console.warn('[WARN]', ...args),
  error: (...args) => console.error('[ERROR]', ...args),
};
/* eslint-enable no-console */

export default log;
